import React from 'react';
import { ControlProps, JsonFormsRendererRegistryEntry, rankWith } from '@jsonforms/core';

export const UnsupportedControl: JsonFormsRendererRegistryEntry = {
  tester: rankWith(
    0, // negative is not a match and positive is a match, so this rank zero strikes a middle ground that will render but only if other positive matches aren't found
    (_anyUiSchema, _anyDataSchema, _anyContext) => true // will match anything as last resort
  ),
  renderer: (props: ControlProps): React.ReactNode => {
    // throw detailed message for logging broken control
    throw new Error(`Unsupported dynamic form control detected:
      Control ID: ${props.id}
      Control label: ${props.label}
      Control description: ${props.description}
      Data Schema Title: ${props.schema?.title}
      Data Schema Type: ${props.schema?.type}
      UI Schema Type: ${props.uischema?.type}
      UI Schema Scope: ${props.uischema?.scope}
    `);
  },
};
